import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { subDays } from "date-fns";
import ReactECharts from "echarts-for-react";
import {  useLocation  } from "react-router-dom";

import Navbar from "../../components/universal/Navbar";
import SearchBar from "../../components/universal/SearchBar";
import SingleTab from "../../components/universal/SingleTab";
import DateFilter from "../../components/universal/DateFilter";
import SquareCard from "../../components/universal/SquareCard";
import CustomCarousel from "../../components/universal/CustomCarousel";

import { CategoriesHooks, GetRelatedVideosHooks } from "./hooks/CategoriesHooks";
import { categoriesDashboardAction } from "../../store/Dashboard/DashboardAction";
import { downloadExcel } from "../../utils/DownloadExcel";

import userIcon from "../../assets/icons/userIcon.svg";
import squareIcon1 from "../../assets/icons/squareCard/icon1.svg";
import { AiOutlinePlus, AiOutlineReload } from "react-icons/ai";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";
import { FaDownload } from "react-icons/fa6";
import { useSelector } from "react-redux";
function Categories() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // search bar component state with handler
  const { value, onChangeSearchBar } = CategoriesHooks();
  // tab clicking state for language table
  const [activeTab, setActiveTab] = useState("Trending");
  const [userTab, setUserTab] = useState("By Language");
  const [loading, setLoading] = useState(true);
  const [byLanguage, setByLanguage] = useState({ xAxis: [], yAxis: [] });
  const [byCountry, setByCountry] = useState({ xAxis: [], yAxis: [] });
  const [byLanguageData, setByLanguageData] = useState({ xAxis: [], yAxis: [] });
  const [trendingCategories, setTrendingCategories] = useState({ xAxis: [], yAxis: [] });
  const [mostLikedCategories, setMostLikedCategories] = useState({ xAxis: [], yAxis: [] });
  const [languageTabData, setLanguageTabData] = useState({ xAxis: [], yAxis: [] });

  const { options } = GetRelatedVideosHooks();

  const handleSeeAllCategories = () => {
    navigate("/categories/all", { state: { options: options } });
  };

  const handleAddCategories = () => {
    navigate("/categories/add", { state: { options: options } });
  };

  const [animate, setAnimate] = useState(false);

  const [filterRange, setFilterRange] = useState([
    {
      startDate: subDays(new Date(), 7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const fetchReportsData = ({ startDate, endDate }) => {
    setLoading(true);

    const categoriesPromise = new Promise((resolve, reject) => {
      dispatch(
        categoriesDashboardAction({
          apiPayloadRequest: {
            startDate: startDate ?? null,
            endDate: endDate ?? null,
          },
          callback: (res) => {
            const data = res?.data ? res?.data : [];

            const tempByLanguage = {
              xAxis: data
                ?.filter((item) => item.dash === "Language based Category likes")[0]
                ?.data?.map((item) => ({ ...item, value: item?._id })),
              yAxis: data
                ?.filter((item) => item.dash === "Language based Category likes")[0]
                ?.data?.map((item) => ({ ...item, name: item?._id, value: item?.count })),
            };

            setByLanguageData(tempByLanguage);

            setByLanguage(tempByLanguage);
            setByCountry({
              xAxis: data
                ?.filter((item) => item.dash === "Country based Category Likes")[0]
                ?.data?.map((item) => ({ ...item, value: item?._id })),
              yAxis: data
                ?.filter((item) => item.dash === "Country based Category Likes")[0]
                ?.data?.map((item) => ({ ...item, name: item?._id, value: item?.count })),
            });

            const tempTrendingCategory = {
              xAxis: data
                ?.filter((item) => item?.dash === "Trending Categories")[0]
                ?.data?.map((d) => ({ ...d, value: d?.recentViews })),
              yAxis: data
                ?.filter((item) => item?.dash === "Trending Categories")[0]
                ?.data?.map((d) => ({ ...d, value: d?.title })),
            };

            setLanguageTabData(tempTrendingCategory);

            setTrendingCategories(tempTrendingCategory);
            setMostLikedCategories({
              xAxis: data
                ?.filter((item) => item?.dash === "Most Like Categories")[0]
                ?.data?.map((d) => ({ ...d, value: d?.likeCount })),
              yAxis: data
                ?.filter((item) => item?.dash === "Most Like Categories")[0]
                ?.data?.map((d) => ({ ...d, value: d?.title })),
            });
            resolve();
          },
        })
      );
    });

    Promise.all([categoriesPromise]).finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchReportsData({
      startDate: filterRange?.[0]?.startDate,
      endDate: filterRange?.[0]?.endDate,
    });
  }, [filterRange]);
    const location = useLocation();
    const { userInfo } = useSelector((state) => state.user);

  const hideUI = location.pathname.includes("addfield")|| userInfo?.roleCode==='17dwer8'||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");

  return (
    <div className="App bg-[#191919] h-fit min-h-screen flex ">
     { !hideUI &&<Navbar />}
      <div className={`flex-1 ${!hideUI&&'md:pl-32'} md:pt-0 pt-20`}>
      <div className={`flex flex-col gap-4 h-full ${hideUI &&'max-w-[367px]'}`}>

          {!hideUI && <SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />}
          <div
            className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4 relative"
            id="reportContainer"
          >
           { !hideUI &&<div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
              <div className="flex justify-between items-center flex-1">
                <p className=" text-white text-3xl font-medium flex items-center gap-3">
                  Categories{" "}
                  <AiOutlineReload
                    className={`cursor-pointer text-2xl text-yellowish ${
                      loading ? "animate-spin" : ""
                    }`}
                    onClick={() =>
                      fetchReportsData({
                        startDate: filterRange?.[0]?.startDate,
                        endDate: filterRange?.[0]?.endDate,
                      })
                    }
                  />
                </p>
                <p className="flex gap-3 items-center">
                  <DateFilter range={filterRange} setRange={setFilterRange} />
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  onClick={handleSeeAllCategories}
                  className=" text-[13px] text-greyish border px-4 py-2 border-greyish bg-blackish rounded-xl"
                >
                  See All Categories
                </button>

                <button
                  onClick={handleAddCategories}
                  className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
                >
                  <AiOutlinePlus /> Add New Category
                </button>
              </div>
            </div>
}
<div className={`${!hideUI?'flex gap-4 flex-wrap':'grid grid-cols-1 gap-4 pl-4 w-fit'}`}>


              <SquareCard
                heading={"No. of Trending Categories"}
                icon={squareIcon1}
                iconStyle={"h-11 w-11"}
                info={trendingCategories?.xAxis?.length}
                downloadIcon={true}
                downloadIconClickHandle={() => {
                  downloadExcel([
                    ...(trendingCategories?.xAxis?.map((d) => ({
                      "Category Name": d?.title,
                      "Total Likes": d?.value,
                    })) ?? []),
                  ]);
                }}
                trail={""}
                handleOnClick={() => {
                  setAnimate((prev) => !prev);
                  setActiveTab("Trending");
                  setLanguageTabData(trendingCategories);
                }}
              />
              <SquareCard
                heading={"No. of most liked Categories"}
                icon={userIcon}
                iconStyle={"h-11 w-11"}
                info={mostLikedCategories?.xAxis?.length}
                downloadIcon={true}
                downloadIconClickHandle={() => {
                  downloadExcel([
                    ...(mostLikedCategories?.xAxis?.map((d) => ({
                      "Category Name": d?.title,
                      "Total Likes": d?.value,
                    })) ?? []),
                  ]);
                }}
                trail={""}
                handleOnClick={() => {
                  setAnimate((prev) => !prev);
                  setActiveTab("Most Liked");
                  setLanguageTabData(mostLikedCategories);
                }}
              />
              {/* <SquareCard
                heading={"No. of most watched videos"}
                icon={userIcon}
                iconStyle={"h-11 w-11"}
                info={mostWatchedVideos?.length || 0}
                trail={""}
                percentage={"0%"}
                handleOnClick={() => {
                  setAnimate((prev) => !prev);
                  setLanguageTabHeaders(mostWatchedVideosHeader);
                  setLanguageTabData([]);
                }}
              /> */}
            </div>
            <div className={`${!hideUI ?'grid grid-rows-1 md:grid-cols-6 grid-cols-1 flex-1 h-full gap-x-4 gap-y-4 my-4':'space-y-4 max-w-[100%] ml-4 '}`}>
              <div className="md:col-span-3 row-span-1 bg-blackishV2 px-6 py-4 rounded-2xl flex justify-between">
                <div className="text-white w-full">
                  <div className="flex justify-between items-center w-full">
                    <div className="flex items-center gap-8">
                      <p className="text-lg font-semibold text-white">Viewership Reports</p>
                      {/* <p className="text-gray-400">Hindi</p> */}
                    </div>
                    <div className="md:w-[25vw] w-full">
                      <div className="md:block hidden">
                        <CustomCarousel
                          rows={1}
                          cols={2}
                          gapX={0}
                          gapY={0}
                          // easier to pass this array like this rather than separating it
                          completeSliders={[
                            <SingleTab activeTab={userTab} tab={"By Language"} />,
                            <SingleTab activeTab={userTab} tab={"By Country"} />,
                          ]}
                          numberOfCardsShownInSingleSlide={2}
                          handleCardOnClick={(card) => {
                            setUserTab(card.props.tab);
                            switch (card.props.tab) {
                              case "By Language":
                                setByLanguageData(byLanguage);
                                break;
                              case "By Country":
                                setByLanguageData(byCountry);
                                break;
                              // add other tabs here
                              default:
                                break;
                            }
                          }}
                          topNext={"hidden"}
                          topPrev={"hidden"}
                        />
                      </div>
                      <div className="md:hidden block">
                        <CustomCarousel
                          rows={1}
                          cols={2}
                          gapX={0}
                          gapY={0}
                          // easier to pass this array like this rather than separating it
                          completeSliders={[
                            <SingleTab activeTab={userTab} tab={"By Language"} />,
                            <SingleTab activeTab={userTab} tab={"By Country"} />,
                          ]}
                          numberOfCardsShownInSingleSlide={2}
                          handleCardOnClick={(card) => {
                            setUserTab(card.props.tab);
                            switch (card.props.tab) {
                              case "By Language":
                                setByLanguageData(byLanguage);
                                break;
                              case "By Country":
                                setByLanguageData(byCountry);
                                break;
                              // add other tabs here
                              default:
                                break;
                            }
                          }}
                          topNext={"hidden"}
                          topPrev={"hidden"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="block relative">
                    <button
                      className="text-yellowish absolute top-2 right-2 z-50"
                      onClick={() => {
                        downloadExcel([
                          ...(byLanguageData?.yAxis?.map((d) => ({
                            [`${userTab === "By Language" ? "Language" : "Country"}`]: d?.name,
                            "Total Likes": d?.value,
                          })) ?? []),
                        ]);
                      }}
                    >
                      <FaDownload />
                    </button>
                    <ReactECharts
                      className="py-4 bg-blackish mt-5 !h-[350px]"
                      option={{
                        tooltip: {
                          trigger: "item",
                          formatter: "{b} ({c})",
                        },
                        series: [
                          {
                            name: "Language",
                            type: "pie",
                            radius: [20, 140],
                            center: ["50%", "50%"],
                            roseType: "area",
                            itemStyle: {
                              borderRadius: 5,
                            },
                            label: {
                              color: "#fff",
                            },
                            data: [...byLanguageData?.yAxis],
                            color: [
                              ...byLanguageData?.yAxis?.map(
                                (item, index) =>
                                  `rgba(239,188,81, ${(0.5 + Math.random() / 2).toFixed(2)})`
                              ),
                            ],
                          },
                        ],
                        responsive: true,
                      }}
                      notMerge={true}
                      lazyUpdate={true}
                      theme={"halloween"}
                      onChartReady={() => undefined}
                    />
                  </div>
                </div>
              </div>
              <div className="md:col-span-3 row-span-1 bg-blackishV2 px-6 py-4 rounded-2xl flex flex-col gap-4">
                <div className="flex justify-between md:items-center md:flex-row flex-col gap-4">
                  <p className="text-lg font-semibold text-white">Category List</p>
                  <div className="md:w-[20vw] w-full">
                    <CustomCarousel
                      rows={1}
                      cols={2}
                      gapX={0}
                      gapY={0}
                      // easier to pass this array like this rather than separating it
                      completeSliders={[
                        <SingleTab activeTab={activeTab} tab={"Trending"} />,
                        <SingleTab activeTab={activeTab} tab={"Most Liked"} />,
                      ]}
                      numberOfCardsShownInSingleSlide={2}
                      handleCardOnClick={(card) => {
                        setActiveTab(card.props.tab);
                        switch (card.props.tab) {
                          case "Trending":
                            setLanguageTabData(trendingCategories);
                            break;
                          case "Most Liked":
                            setLanguageTabData(mostLikedCategories);
                            break;
                          // add other tabs here
                          default:
                            break;
                        }
                      }}
                      topNext={"top-3"}
                      topPrev={"top-9"}
                    />
                  </div>
                </div>
                <div
                  className={`${
                    animate
                      ? "absolute bg-blackishV2 w-full h-full left-0  top-0 p-5 rounded-lg z-50 transition-all duration-500 ease-out overflow-y-auto"
                      : "transition-all duration-500 ease-in-out"
                  }`}
                >
                  {animate && (
                    <button
                      className="flex gap-2 font-bold text-xs px-4 py-2 bg-yellowish rounded-md"
                      onClick={() => setAnimate((prev) => !prev)}
                    >
                      <FaRegArrowAltCircleLeft size={16} /> <p>Back</p>
                    </button>
                  )}
                  <div className="w-full h-full relative">
                    <button
                      className="text-yellowish absolute top-2 right-2 z-50"
                      onClick={() => {
                        downloadExcel([
                          ...(languageTabData?.xAxis?.map((d) => ({
                            "Category Name": d?.title,
                            "Total Likes": d?.value,
                          })) ?? []),
                        ]);
                      }}
                    >
                      <FaDownload />
                    </button>
                    <ReactECharts
                      key={languageTabData?.yAxis?.length}
                      className="py-4 bg-blackish mt-5"
                      onEvents={{
                        click: (e) => {
                          if (e?.componentType === "series") {
                            navigate("/categories/add", {
                              state: {
                                _id: e?.data?._id,
                              },
                            });
                          }
                        },
                      }}
                      option={{
                        resposive: true,
                        // maintainAspectRatio: true,
                        tooltip: {
                          trigger: "axis",
                          axisPointer: {
                            type: "shadow",
                          },
                        },
                        grid: {
                          left: "3%",
                          right: "4%",
                          bottom: "3%",
                          containLabel: true,
                        },
                        yAxis: [
                          {
                            type: "category",
                            data: [...languageTabData?.yAxis],
                            axisLabel: { width: 100, overflow: "truncate" },
                            axisTick: { show: false },
                            // triggerEvent: true,
                          },
                        ],
                        xAxis: [
                          {
                            // triggerEvent: true,
                            type: "value",
                            splitLine: {
                              show: false,
                              lineStyle: {
                                type: "dashed",
                              },
                            },
                          },
                        ],
                        series: [
                          {
                            name: "Most Liked",
                            type: "bar",
                            barWidth: "65%",
                            data: [...languageTabData?.xAxis],
                            color: ["#EFBC51"],
                            itemStyle: {
                              normal: {
                                shadowColor: "rgb(239,188,81, 0.3)",
                                shadowBlur: 15,
                              },
                            },
                          },
                        ],
                        graph: {},
                      }}
                      notMerge={true}
                      lazyUpdate={true}
                      theme={"halloween"}
                      onChartReady={() => undefined}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Categories;
